<template>
    <dk-button
        class="tw-w-full tw-font-bold tw-text-center tw-bg-brand-primary !tw-h-12 !tw-text-lg"
        type="button"
        variant="primary"
        @click.prevent="onClick"
    >
        <dk-icon name="facebook-filled-inverted" size="s" class="tw-text-brand-primary tw-mr-1" />
        <slot></slot>
    </dk-button>
</template>

<script>
import DkButton from '@v4/common/components/atoms/DkButton.vue';
import DkIcon from '@v4/common/components/atoms/DkIcon.vue';

export default {
    name: 'FacebookLoginButton',
    components: {
        DkButton,
        DkIcon,
    },
    methods: {
        onClick(e) {
            /**
             * Fired when button clicked.
             *
             * @event click
             * @type {Event}
             * @property {Event} e - Click event
             */
            this.$emit('click', e);
        },
    },
};
</script>
